import styled from '@emotion/styled';

import color from '../../theme/color';

const S = {
    Root: styled('div')({
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'start',
        paddingLeft: '24px',
        backgroundColor: color.blackRock,
        flexDirection: 'column',
        gap: '10px',
        marginTop: '10px',
        marginBottom: '10px'
    }),
    CompactRoot: styled('div')({
        display: 'flex',
        alignItems: 'start',
        flexDirection: 'column',
        gap: '4px',
        marginTop: '4px'
    }),
    labelTitle: {
        height: '17px',
        marginTop: '14px',
        color: color.white90,
        fontWeight: '600',
        fontFamily: 'Inter',
        fontSize: '14px',
        lineHeight: '16.94px'
    },
    labelInstructions: {
        color: color.white30,
        fontWeight: '400',
        fontFamily: 'Inter',
        fontSize: '13px',
        lineHeight: '23px'
    },
    input: {
        backgroundColor: color.blackRock,
        padding: '20px',
        color: color.white90,
        border: `0.5px solid ${color.white10}`,
        paddingRight: '2rem'
    },
    HiddenInput: styled('input')({
        display: 'none'
    }),
    TitleExclamation: styled('span')({
        color: color.lightningYellow,
        marginLeft: '5px',
        position: 'relative',
        display: 'inline-block'
    }),
    AttachmentsContainer: styled('div')({
        padding: 12
    }),
    AttachmentsList: styled('div')({
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        flexWrap: 'wrap',
        gap: '8px',
        maxHeight: '150px',
        overflowY: 'auto'
    }),
    AttachmentButton: styled('div')({
        cursor: 'pointer',
        display: 'flex',
        alignItems: 'center',
        padding: '4px',
        marginRight: '4px'
    })
};

export default S;
